// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-row > .col > .text-muted {\n    margin-top: 0;\n    font-size: 12px;\n    font-style: italic;\n}\n", ""]);
// Exports
module.exports = exports;
